import { http } from "../../../shared/api/http"

/* ===== ADMIN USERS (full list, incl. banned) ===== */
export type AdminUserRole = "user" | "mentor" | "admin"

export type AdminUserItem = {
  user_id: string
  email: string
  role: AdminUserRole
  is_banned: boolean
  created_at: number
  full_name: string | null
  phone_number?: string | null
  city?: string | null
  industry?: string | null
  experience_level?: string | null
  avatar?: string | null
  push_enabled?: boolean
}

export type AdminUserListResponse = {
  items: AdminUserItem[]
  total: number
}

export type AdminUserFilters = {
  limit?: number
  offset?: number
  role?: AdminUserRole | ""
  is_banned?: boolean
  search?: string
}

export const listAdminUsersApi = (filters: AdminUserFilters) =>
  http.get<AdminUserListResponse>("/api/admin/users", {
    params: { ...filters, role: filters.role || undefined },
  })

export type UserProfileItem = {
  user_id: string
  full_name: string | null

  phone_number?: string | null
  city?: string | null
  industry?: string | null
  experience_level?: string | null
}

export type UserProfileListResponse = {
  items: UserProfileItem[]
  total: number
}

/* ===== MENTORS ===== */
export const listMentorsApi = (
  limit = 100,
  offset = 0
) =>
  http.get<UserProfileListResponse>(
    "/api/profiles",
    {
      params: {
        limit,
        offset,
        role: "mentor",
      },
    }
  )

/* ===== CREATE MENTOR ===== */
export type CreateMentorPayload = {
  email: string
  password: string
  phone_number?: string
}

export const createMentorApi = (
  data: CreateMentorPayload
) =>
  http.post<{ user_id: string }>(
    "/api/admin/users/register/mentor",
    data
  )

/* ===== UPDATE MENTOR ===== */
export type UpdateMentorPayload = {
  full_name?: string | null
  bio?: string | null
  date_of_birth?: string | null
  city?: string | null
  industry?: string | null
  experience_level?: string | null
}

export const updateMentorApi = (
  userId: string,
  data: UpdateMentorPayload
) =>
  http.patch(
    `/api/admin/users/mentor/${userId}/update`,
    data
  )

/* ===== DELETE USER ===== */
export const deleteAdminUserApi = (userId: string) =>
  http.delete(`/api/admin/users/${userId}`)

/* ===== BAN / UNBAN USER ===== */
export const banAdminUserApi = (userId: string) =>
  http.post(`/api/admin/users/${userId}/ban`)

export const unbanAdminUserApi = (userId: string) =>
  http.post(`/api/admin/users/${userId}/unban`)

/* ===== UPLOAD AVATAR ===== */
export const uploadMentorAvatarApi = (
  userId: string,
  file: File
) => {
  const form = new FormData()
  form.append("file", file)

  return http.post(
    `/api/admin/users/mentor/${userId}/upload/avatar`,
    form,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  )
}
